module.exports = __webpack_public_path__ + "static/media/earthquake-purplish-blue.34520aed.svg";